import html2canvas from 'html2canvas';

declare global {
  interface Window {
    SunmiPrinter?: {
      isConnected: () => boolean;
      printBitmap: (base64: string) => void;
      getPrinterStatus: () => string;
      openCashDrawer: () => void;
    };
  }
}

export function isSunmiDevice(): boolean {
  return window.SunmiPrinter != null || navigator.userAgent.includes('SunmiPOS');
}

export function openSunmiDrawer(): void {
  if (!isSunmiDevice()) return;
  try {
    window.SunmiPrinter?.openCashDrawer?.();
  } catch (err) {
    console.warn('Cash drawer open failed:', err);
  }
}

export async function printOnSunmi(element: HTMLElement, copies = 1): Promise<void> {
  if (!window.SunmiPrinter) {
    throw new Error('SunmiPrinter bridge not available');
  }

  if (!window.SunmiPrinter.isConnected()) {
    throw new Error('Printer not ready. Please check the printer and try again.');
  }

  const originalWidth = element.style.width;
  element.style.width = '576px';

  let base64: string;
  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
    });
    base64 = canvas.toDataURL('image/png');
  } finally {
    element.style.width = originalWidth;
  }

  for (let i = 0; i < copies; i++) {
    window.SunmiPrinter.printBitmap(base64);
  }
}
